import Vue from "vue";
import Router from "vue-router";
import LayoutPublic from "./layouts/LayoutPublic";
import LayoutPrivate from "./layouts/LayoutPrivate";
import Login from "./components/public/auth/Login";
import ReportDefect from "./views/public/ReportDefect";
import { store } from "./vuex/store";

// Private
import Dashboard from "./views/private/Dashboard";
import Defects from "./views/private/Defects";
import DefectsEdit from "./views/private/DefectsEdit";
import Administration from "./views/private/administration/Administration";
import EditUser from "./views/private/administration/EditUser";
import NewUser from "./views/private/administration/NewUser";
import DefectsHistory from "@/views/private/DefectsHistory"
import DefectsHistoryDetail from "@/views/private/DefectsHistoryDetail"

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/private/dashboard");
};

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next();
        return;
    }
    next("/");
};

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            component: LayoutPublic,
            children: [
                {
                    path: "",
                    name: "home",
                    component: Login,
                    beforeEnter: ifNotAuthenticated
                },
                {
                    path: "login",
                    name: "login",
                    component: Login,
                    beforeEnter: ifNotAuthenticated
                },
                {
                    path: "hlasenie-poruchy/:city?/:point(.*)?",
                    name: "reportdefect",
                    component: ReportDefect,
                    props: true
                }
            ]
        },
        {
            path: "/private",
            name: "private",
            component: LayoutPrivate,
            beforeEnter: ifAuthenticated,
            children: [
                {
                    path: "dashboard/:mapType?/:point?",
                    name: "dashboard",
                    component: Dashboard
                },
                {
                    path: "defects",
                    name: "defects",
                    component: Defects
                },
                {
                    path: "defects/edit/:id",
                    name: "defectsEdit",
                    component: DefectsEdit
                },
                {
                    path: "defects-history/:id",
                    name: "defectsHistoryDetail",
                    component: DefectsHistoryDetail
                },
                {
                    path: "defects-history",
                    name: "defectsHistory",
                    component: DefectsHistory
                },
                {
                    path: "administration",
                    name: "administration",
                    component: Administration
                },
                {
                    path: "administration/user/create",
                    name: "createUser",
                    component: NewUser
                },
                {
                    path: "administration/user/:id/edit",
                    name: "editUser",
                    component: EditUser
                }
            ]
        }
    ]
});
